export const colorWarning = "rgb(247, 178, 40)";
export const colorGrayDarker = "rgb(101, 119, 135)";
export const colorGrayLighter = "rgb(245, 248, 250)";
export const colorCategoryHome = "rgb(211, 36, 131)";
export const colorPrimary = "rgb(0, 119, 179)";
export const colorCategoryVehicle = "rgb(54, 74, 129)";
export const colorSuccess = "rgb(0, 135, 90)";
export const colorCategoryFamily = "rgb(11, 114, 136)";
export const colorPrimaryLightest = "rgb(243, 249, 252)";
export const colorPrimaryLighter = "rgb(230, 242, 248)";
export const colorBrandBlue = "rgb(0, 161, 212)";
export const colorPrimaryDark = "rgb(0, 77, 128)";
export const colorGrayLightest = "rgb(255, 255, 255)";
export const colorCategoryFinance = "rgb(122, 1, 196)";
export const colorGrayDark = "rgb(144, 149, 153)";
export const colorGrayLight = "rgb(225, 227, 230)";
export const colorSecondary = "rgb(0, 41, 77)";
export const colorCategoryPet = "rgb(168, 1, 78)";
export const colorPrimaryLight = "rgb(205, 229, 241)";
export const colorCategoryTravel = "rgb(213, 66, 3)";
export const colorGray = "rgb(207, 210, 212)";
export const colorDanger = "rgb(222, 35, 98)";
export const colorGrayDarkerTurva = "rgb(68, 68, 69)";
export const colorGrayLighterTurva = "rgb(245, 245, 247)";
export const colorCategoryHomeTurva = "rgb(161, 10, 78)";
export const colorPrimaryTurva = "rgb(198, 12, 48)";
export const colorCategoryVehicleTurva = "rgb(23, 28, 58)";
export const colorSuccessTurva = "rgb(8, 135, 78)";
export const colorPrimaryLightestTurva = "rgb(252, 243, 244)";
export const colorCategoryFamilyTurva = "rgb(199, 12, 112)";
export const colorCategoryUnionTurva = "rgb(169, 69, 124)";
export const colorPrimaryLighterTurva = "rgb(249, 230, 234)";
export const colorPrimaryDarkTurva = "rgb(148, 9, 37)";
export const colorGrayLightestTurva = "rgb(255, 255, 255)";
export const colorGrayDarkTurva = "rgb(116, 116, 117)";
export const colorGrayLightTurva = "rgb(228, 228, 230)";
export const colorBrandGrayTurva = "rgb(178, 180, 179)";
export const colorSecondaryTurva = "rgb(23, 28, 58)";
export const colorPrimaryLightTurva = "rgb(244, 207, 214)";
export const colorCategoryTravelTurva = "rgb(9, 129, 148)";
export const colorGrayTurva = "rgb(207, 207, 209)";
export const colorDangerTurva = "rgb(224, 42, 13)";
export const colorWarningTurva = "rgb(250, 164, 15)";
export const colorData07 = "rgb(192, 101, 247)";
export const colorData08 = "rgb(0, 105, 191)";
export const colorData09 = "rgb(19, 120, 53)";
export const colorData10 = "rgb(179, 60, 24)";
export const colorData11 = "rgb(13, 163, 166)";
export const colorData01 = "rgb(122, 1, 196)";
export const colorData12 = "rgb(11, 114, 136)";
export const colorData02 = "rgb(0, 155, 204)";
export const colorData13 = "rgb(179, 137, 24)";
export const colorData03 = "rgb(27, 171, 75)";
export const colorData14 = "rgb(128, 98, 17)";
export const colorData04 = "rgb(255, 86, 34)";
export const colorData15 = "rgb(0, 41, 77)";
export const colorData05 = "rgb(245, 76, 154)";
export const colorData06 = "rgb(194, 21, 101)";
export const fontWeightExtraBold = "800";
export const letterSpacingHeading = "-0.01rem";
export const fontFamilyHeadingTurva = "'turva-sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
export const fontFamilyTextTurva = "'turva-sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
export const fontFamilyHeading = "'localtapiola-sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
export const fontFamilyText = "'localtapiola-sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
export const fontWeightBold = "700";
export const fontWeightNormal = "400";
export const fontWeightSemiBold = "600";
export const fontSizeXxxxLarge = "4.5rem";
export const fontSizeXxxLarge = "3rem";
export const fontSizeXxLarge = "2.25rem";
export const fontSizeXLarge = "1.5rem";
export const fontSizeLarge = "1.25rem";
export const fontSizeMedium = "1rem";
export const fontSizeSmall = "0.875rem";
export const fontSizeXSmall = "0.75rem";
export const radiusSharp = "0";
export const radiusDefault = "4px";
export const radiusCircle = "50%";
export const radiusPill = "20rem";
export const shadowTooltipTurva = "0 2px 10px 0 rgba(117, 117, 117, 0.13)";
export const shadowDefault = "0 2px 6px 0 rgba(0, 41, 77, 0.07)";
export const shadowTooltip = "0 2px 10px 0 rgba(0, 41, 77, 0.07)";
export const shadowCardTurva = "0 2px 6px 0 rgba(117, 117, 117, 0.13), 0 -1px 0 0 rgba(0, 0, 0, 0.09), -1px 0 0 0 rgba(0, 0, 0, 0.07), 1px 0 0 0 rgba(0, 0, 0, 0.07), 0 1px 0 0 rgba(0, 0, 0, 0.07)";
export const shadowModal = "0 2px 20px 0 rgba(0, 0, 0, 0.2)";
export const shadowCard = "0 2px 6px 0 rgba(0, 41, 77, 0.07), 0 -1px 0 0 rgba(0, 0, 0, 0.09), -1px 0 0 0 rgba(0, 0, 0, 0.07), 1px 0 0 0 rgba(0, 0, 0, 0.07), 0 1px 0 0 rgba(0, 0, 0, 0.07)";
export const shadowHoverTurva = "0 2px 10px 0 rgba(117, 117, 117, 0.15)";
export const shadowHover = "0 2px 10px 0 rgba(0, 41, 77, 0.1)";
export const shadowDefaultTurva = "0 2px 6px 0 rgba(117, 117, 117, 0.13)";
export const spaceXxSmall = "4px";
export const spaceLarge = "20px";
export const spaceXSmall = "8px";
export const spaceXxxSmall = "2px";
export const spaceSmall = "12px";
export const spaceMedium = "16px";
export const spaceXxLarge = "36px";
export const spaceXxxxLarge = "72px";
export const spaceXxxxxLarge = "94px";
export const spaceXxxLarge = "48px";
export const spaceXLarge = "28px";
export const sizeIconXxLarge = "48px";
export const sizeFormBorder = "1px";
export const sizeStepMedium = "40px";
export const sizeButtonMinWidth = "8rem";
export const sizeHeader = "4rem";
export const sizeIconXxxLarge = "72px";
export const sizeIconXLarge = "36px";
export const sizeIconXxSmall = "10px";
export const sizeStepSmall = "30px";
export const sizeNavigation = "3rem";
export const sizeIconLarge = "30px";
export const sizeLayoutMaxWidth = "1110px";
export const sizeTappableSquare = "48px";
export const sizeIconXSmall = "16px";
export const sizeIconXxxSmall = "7px";
export const sizeButtonBorder = "2px";
export const sizeButtonTinyBorder = "1px";
export const sizeIconMedium = "24px";
export const sizeIconSmall = "20px";
export const opacity85 = "0.85";
export const opacity75 = "0.75";
export const opacity50 = "0.50";
export const opacity30 = "0.30";
export const zIndexMaskButtons = "250";
export const zIndexDropdown = "600";
export const zIndexSpinner = "800";
export const zIndexDefault = "1";
export const zIndexToast = "500";
export const zIndexPopup = "950";
export const zIndexModal = "900";
export const zIndexSticky = "300";
export const zIndexMasked = "100";
export const zIndexDeep = "-999999";
export const zIndexOverlay = "700";
export const zIndexMask = "200";
export const zIndexHeader = "400";
export const lineHeightMedium = "1.5";
export const lineHeightSmall = "1.25";
export const lineHeightXSmall = "1.1";
export const transitionQuickly = "300ms ease";
export const transitionSlowly = "600ms ease";
export const mediaQueryXxxLarge = "'(min-width: 106.25em)'";
export const mediaQueryXLarge = "'(min-width: 64.0625em)'";
export const mediaQueryMedium = "'(min-width: 48em)'";
export const mediaQueryLarge = "'(min-width: 62em)'";
export const mediaQueryXxLarge = "'(min-width: 76.25em)'";
export const mediaQueryXSmall = "'(max-width: 35.9375em)'";
export const mediaQueryXxxSmall = "'(max-width: 20.5em)'";
export const mediaQuerySmall = "'(min-width: 36em)'";
export const mediaQueryXxSmall = "'(max-width: 22.5em)'";